import * as React from "react";
import Svg, {
    Defs,
    Path,
    G,
    Mask,
    Use,
    Circle,
    ClipPath,
    SvgProps,
} from "react-native-svg";

export const CloseIcon = ({ width = "24", height = "24", color }: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 36 36">
        <Path
            d="M35.063 4.374 31.626.938 18 14.563 4.374.937.938 4.374 14.563 18 .937 31.626l3.437 3.437L18 21.437l13.626 13.626 3.437-3.437L21.437 18z"
            fill="#073350"
            fillRule="evenodd"
        />
    </Svg>
);

export const LockIcon = ({ width = "24", height = "24", color }: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 40 53">
        <Path
            d="M35 18h-2.5v-5C32.5 6.1 26.9.5 20 .5S7.5 6.1 7.5 13v5H5c-2.75 0-5 2.25-5 5v25c0 2.75 2.25 5 5 5h30c2.75 0 5-2.25 5-5V23c0-2.75-2.25-5-5-5ZM20 40.5c-2.75 0-5-2.25-5-5s2.25-5 5-5 5 2.25 5 5-2.25 5-5 5ZM27.75 18h-15.5v-5c0-4.275 3.475-7.75 7.75-7.75s7.75 3.475 7.75 7.75v5Z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </Svg>
);

export const TrashIcon = ({ width = "24", height = "24", color }: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 36 46">
        <Path
            d="M3 40.5c0 2.75 2.25 5 5 5h20c2.75 0 5-2.25 5-5v-30H3v30ZM35.5 3h-8.75L24.25.5h-12.5L9.25 3H.5v5h35V3Z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </Svg>
);

export const AddBookmark = ({
    width = 60,
    height = 60,
    color = "#073350",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        color={color}
        width={width}
        height={height}
        viewBox="0 0 384 512">
        <Path
            fill="currentColor"
            d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
        />
    </Svg>
);

export const RemoveBookmark = ({
    width = 60,
    height = 60,
    color = "#073350",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={width}
        color={color}
        viewBox="0 0 384 512">
        <Path
            fill="currentColor"
            d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
        />
    </Svg>
);

export const CorrectAnswerIcon = ({
    width = 72,
    height = 72,
    color = "#58C4C6",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 72 72">
        <Path
            d="M36 .844a35.157 35.157 0 0 1 0 70.312A35.156 35.156 0 0 1 36 .844Zm0 5.858a29.287 29.287 0 0 0-20.715 8.583 29.287 29.287 0 0 0 0 41.43 29.287 29.287 0 0 0 41.43 0 29.287 29.287 0 0 0 0-41.43A29.287 29.287 0 0 0 36 6.702Zm19.476 15.683a2.93 2.93 0 0 1 .154 3.977L32.193 49.8h-.003a2.924 2.924 0 0 1-2.049.849c-.78.005-1.527-.3-2.081-.85L16.34 38.08h.003a2.93 2.93 0 0 1 4.13-4.13l9.669 9.64L51.499 22.23a2.928 2.928 0 0 1 3.977.154Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const IncorrectAnswerIcon = ({
    width = 72,
    height = 72,
    color = "#58C4C6",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 72 72">
        <Path
            d="M36 .844a35.157 35.157 0 0 1 0 70.312A35.156 35.156 0 0 1 36 .844Zm0 5.858a29.287 29.287 0 0 0-20.715 8.583 29.287 29.287 0 0 0 0 41.43 29.287 29.287 0 0 0 41.43 0 29.287 29.287 0 0 0 0-41.43A29.287 29.287 0 0 0 36 6.702ZM46.8 20.56c2.991-2.992 7.632 1.649 4.64 4.64L40.64 36l10.8 10.8c2.992 2.991-1.649 7.632-4.64 4.64L36 40.64l-10.8 10.8c-2.991 2.992-7.632-1.649-4.64-4.64L31.36 36l-10.8-10.8c-2.992-2.991 1.649-7.632 4.64-4.64L36 31.36Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const PhoneIcon = ({
    width = 60,
    height = 60,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 60 60">
        <G fill="none" fillRule="evenodd">
            <Path
                d="M16.55 26.975c3.6 7.075 9.4 12.85 16.475 16.475l5.5-5.5a2.486 2.486 0 0 1 2.55-.6c2.8.925 5.825 1.425 8.925 1.425 1.375 0 2.5 1.125 2.5 2.5V50c0 1.375-1.125 2.5-2.5 2.5C26.525 52.5 7.5 33.475 7.5 10c0-1.375 1.125-2.5 2.5-2.5h8.75c1.375 0 2.5 1.125 2.5 2.5 0 3.125.5 6.125 1.425 8.925.275.875.075 1.85-.625 2.55l-5.5 5.5Z"
                fill="currentColor"
            />
        </G>
    </Svg>
);

export const PhoneWhiteIcon = ({
    width = 46,
    height = 46,
    color = "#FFF",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 46 46">
        <G transform="translate(-7 -7)" fill="none" fillRule="evenodd">
            <Path
                d="M16.55 26.975c3.6 7.075 9.4 12.85 16.475 16.475l5.5-5.5a2.486 2.486 0 0 1 2.55-.6c2.8.925 5.825 1.425 8.925 1.425 1.375 0 2.5 1.125 2.5 2.5V50c0 1.375-1.125 2.5-2.5 2.5C26.525 52.5 7.5 33.475 7.5 10c0-1.375 1.125-2.5 2.5-2.5h8.75c1.375 0 2.5 1.125 2.5 2.5 0 3.125.5 6.125 1.425 8.925.275.875.075 1.85-.625 2.55l-5.5 5.5Z"
                fill="currentColor"
            />
        </G>
    </Svg>
);

export const SmsIcon = ({ width = "50", height = "50", color }: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 50 50">
        <Path
            d="M45 0H5C2.25 0 .025 2.25.025 5L0 50l10-10h35c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5ZM17.5 22.5h-5v-5h5v5Zm10 0h-5v-5h5v5Zm10 0h-5v-5h5v5Z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </Svg>
);

export const SmsWhiteIcon = ({
    width = 50,
    height = 50,
    color = "#FFF",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 50 50">
        <Defs>
            <Path
                d="M50 5H10c-2.75 0-4.975 2.25-4.975 5L5 55l10-10h35c2.75 0 5-2.25 5-5V10c0-2.75-2.25-5-5-5ZM22.5 27.5h-5v-5h5v5Zm10 0h-5v-5h5v5Zm10 0h-5v-5h5v5Z"
                id="a"
            />
        </Defs>
        <G transform="translate(-5 -5)" fill="none" fillRule="evenodd">
            <Path d="M0 0h60v60H0z" />
            <Mask id="b" fill="#fff">
                <Use xlinkHref="#a" />
            </Mask>
            <Path fill="#FFF" mask="url(#b)" d="M0 0h60v60H0z" />
        </G>
    </Svg>
);

export const WebsiteIcon = ({
    width = 60,
    height = 60,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 60 60">
        <G fill="none" fillRule="evenodd">
            <Path
                d="M47.5 47.5h-35v-35H30v-5H12.5c-2.775 0-5 2.25-5 5v35c0 2.75 2.225 5 5 5h35c2.75 0 5-2.25 5-5V30h-5v17.5ZM35 7.5v5h8.975L19.4 37.075l3.525 3.525L47.5 16.025V25h5V7.5H35Z"
                fill="currentColor"
            />
        </G>
    </Svg>
);

export const NavigateNextIcon = ({
    width = 26,
    height = 40,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 26 40">
        <Path
            fill="currentColor"
            d="m5.333 0-4.7 4.7L15.9 20 .633 35.3l4.7 4.7 20-20z"
        />
    </Svg>
);

export const ArrowLoopIcon = ({
    width = 126,
    height = 95,
    color = "#FFF",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 126 95">
        <G
            stroke="currentColor"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round">
            <Path
                d="M3 2.713C5 12.407 20.237 43 52.085 43c23.593 0 24.133-25.744 10.387-25.744-18.411 0-15.118 23.915-3.443 44.225 8.494 14.778 20.34 19.778 42.14 17.548"
                strokeWidth={5}
            />
            <Path
                d="M96.412 64.89c6.207 3.25 21.724 8.45 26.64 6.617 4.915-1.833-10.885 9.866-15.746 21.493"
                strokeWidth={4}
                strokeLinejoin="round"
            />
        </G>
    </Svg>
);

export const SafeModeIcon = ({
    width = 59,
    height = 38,
    color = "#073350",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 59 38">
        <Path
            d="M22.57 7.378c.177 0 .357 0 .537.06a4.112 4.112 0 0 0 2.508 2.271c.061.357.18.717.18 1.015.06.717.479 5.975.479 5.975l5.855 1.194c.656.12.836.418.78 1.01-.122.659-.36.778-.957.778-.061 0-6.633-.716-6.633-.716-.479-.059-.896-.479-1.015-1.016l-.36-1.792c-.537.777-1.85 2.628-3.106 4.182l5.316 4.899c.18.18.299.36.418.597l2.808 8.843c.417 1.316.417 2.033-.598 2.45-1.015.418-1.732-.539-2.091-1.255l-3.466-7.886c-.119-.177-.238-.357-.417-.537l-6.094-5.258-6.633 5.377c-.417.3-.835.479-1.314.479-.478 0-.956-.177-1.374-.537L1.18 21.716c-.836-.777-1.135-1.792-.418-2.57.716-.776 1.435-.538 2.27.239l5.438 4.243c.299.238.598.18.836 0l5.017-4.542c.479-1.134 1.853-2.509 2.57-3.524.896-1.195 1.914-4.182 2.45-5.676h-3.048l-1.612 5.14c-.177.536-.357.835-1.134.716-.838-.12-.838-.537-.659-1.195l1.613-6.093c.18-.598.717-.957 1.314-.897 0 0 6.215-.18 6.752-.18ZM57.877.03c.598 0 1.076.537 1.076.957v35.07c0 .597-.478 1.076-1.076 1.076H38.76a1.072 1.072 0 0 1-1.076-1.076V20.524h6.81v2.689c0 .24.24.298.36.18l4.718-4.661c.06-.06.06-.18 0-.299l-4.719-4.66c-.121-.12-.36 0-.36.18v2.688h-6.809V1.107c0-.597.478-1.076 1.076-1.076ZM26.871 2.36a3.406 3.406 0 1 1-.002 6.812 3.406 3.406 0 0 1 .002-6.812Z"
            fill="#073350"
            fillRule="evenodd"
        />
    </Svg>
);

export const NavigationIcon = ({
    width = 60,
    height = 60,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 60 60">
        <G fill="none" fillRule="evenodd">
            <Path
                fill="currentColor"
                d="M30 5 11.25 50.725l1.775 1.775L30 45l16.975 7.5 1.775-1.775z"
            />
        </G>
    </Svg>
);

export const HoursIcon = ({
    width = 60,
    height = 60,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 60 60">
        <G fill="none" fillRule="evenodd">
            <Path
                d="M29.975 5C43.8 5 55 16.2 55 30S43.8 55 29.975 55C16.175 55 5 43.8 5 30S16.175 5 29.975 5ZM30 10c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20Zm1.25 7.5v13.125L42.5 37.3l-1.875 3.075L27.5 32.5v-15h3.75Z"
                fill="currentColor"
            />
        </G>
    </Svg>
);

export const TTYIcon = ({
    width = 60,
    height = 60,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        height={width}
        width={height}
        color={color}
        {...props}
        viewBox="0 0 1792 1792">
        <Path
            fill="currentColor"
            d="M448 1312v192q0 14-9 23t-23 9H224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM256 928v192q0 14-9 23t-23 9H32q-14 0-23-9t-9-23V928q0-14 9-23t23-9h192q14 0 23 9t9 23zm576 384v192q0 14-9 23t-23 9H608q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM640 928v192q0 14-9 23t-23 9H416q-14 0-23-9t-9-23V928q0-14 9-23t23-9h192q14 0 23 9t9 23zM66 768q-28 0-47-19T0 703V574h514v129q0 27-19 46t-46 19H66zm1150 544v192q0 14-9 23t-23 9H992q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zm-192-384v192q0 14-9 23t-23 9H800q-14 0-23-9t-9-23V928q0-14 9-23t23-9h192q14 0 23 9t9 23zm576 384v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zm-192-384v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23V928q0-14 9-23t23-9h192q14 0 23 9t9 23zm384-408v13h-514v-10q0-104-382-102-382 1-382 102v10H0v-13q0-17 8.5-43t34-64 65.5-75.5 110.5-76 160-67.5 224-47.5T896 128t293 18.5 224 47.5 160.5 67.5 110.5 76 65.5 75.5 34 64 8.5 43zm0 408v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23V928q0-14 9-23t23-9h192q14 0 23 9t9 23zm0-354v129q0 27-19 46t-46 19h-384q-27 0-46-19t-19-46V574h514z"
        />
    </Svg>
);

export const RedoIcon = ({
    width = 23,
    height = 10,
    color = "#000",
    ...props
}: SvgProps) => (
    <Svg
        width={width}
        height={height}
        color={color}
        {...props}
        viewBox="0 0 29 13">
        <Path
            d="M23.3 5.575C20.756 3.361 17.456 2 13.812 2 7.42 2 2.015 6.166.117 11.928L3.362 13c1.444-4.386 5.57-7.563 10.45-7.563 2.682 0 5.13.99 7.04 2.586L15.875 13H28.25V.625l-4.95 4.95Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const QuizRedoIcon = ({
    width = 150,
    height = 137,
    color = "#E86451",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 150 136.363725">
        <Path
            d="M148.265531,65.987883 L133.233929,81.137054 C130.302297,84.077433 125.566585,84.077433 122.634953,81.137054 L107.603351,65.987883 C105.045164,62.976594 105.221423,58.502025 107.997994,55.703829 C110.774655,52.90545 115.214317,52.727995 118.202236,55.306099 L118.956288,56.066049 L118.949234,56.05894 C115.918919,43.054689 108.131784,31.6769923 97.137896,24.2114983 C86.144187,16.7398224 72.753938,13.7285337 59.654506,15.78109 C46.5538117,17.8265554 34.7076751,24.7867741 26.4756539,35.2630113 C18.2436326,45.739249 14.2418203,58.955864 15.2636518,72.279571 C16.2855012,85.596369 22.2615013,98.039707 31.9936158,107.116119 C41.7327663,116.185803 54.503133,121.221285 67.757716,121.214194 C71.908545,121.214194 75.277125,124.60203 75.277125,128.785325 C75.277125,132.968619 71.908545,136.363725 67.757716,136.363725 C50.379365,136.391965 33.6569784,129.680238 21.0554732,117.614356 C8.45505044,105.554656 0.948996741,89.063296 0.083037841,71.570476 C-0.776714959,54.077475 5.06536274,36.9248383 16.418444,23.6574954 C27.7644893,10.3903342 43.7466618,2.03738086 61.040582,0.326462763 C78.334321,-1.38520084 95.621205,3.67884406 109.314179,14.4599921 C123.006792,25.2484129 132.054619,40.931041 134.585744,58.260224 L137.594951,55.227481 C140.575834,52.656376 145.022713,52.826922 147.799194,55.62521 C150.575855,58.423588 150.744897,62.905067 148.193837,65.909264 L148.265531,65.987883 Z"
            fill="currentColor"
        />
    </Svg>
);

export const QuizRestartIcon = ({
    width = 50,
    height = 50,
    color = "#E86451",
    ...props
}: SvgProps) => (
    <Svg width={width} height={height} viewBox="0 0 50 50" {...props}>
        <G fill="none" fillRule="evenodd">
            <Circle fill={color} cx={25} cy={25} r={25} />
            <Path
                d="M32.3 22.575C29.756 20.361 26.456 19 22.813 19c-6.394 0-11.798 4.166-13.696 9.927L12.362 30c1.444-4.386 5.57-7.563 10.45-7.563 2.682 0 5.13.99 7.04 2.585L24.875 30H37.25V17.625l-4.95 4.95Z"
                fill="#FFF"
            />
        </G>
    </Svg>
);

export const PointerIcon = ({
    width = "57",
    height = "43",
    color,
}: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 57 43">
        <Path
            d="M26.017 41.336 1.174 4.683A3 3 0 0 1 3.657 0h49.686a3 3 0 0 1 2.483 4.683L30.983 41.336a3 3 0 0 1-4.966 0Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const BackIcon = ({
    width = "36",
    height = "28",
    color = "#073350",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 36 28"
        color={color}>
        <Path
            d="M14.025 0 17 2.97 7.953 12H36v4H7.954L17 25.03 14.025 28 0 14 14.025 0Z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </Svg>
);

export const MenuIcon = ({
    width = "52",
    height = "52",
    color = "#073350",
    ...props
}: SvgProps) => (
    <Svg
        {...props}
        width={width}
        height={height}
        color={color}
        viewBox="0 0 52 52">
        <G fill="none" fillRule="evenodd">
            <Path
                d="M6.328 37.969h37.969V33.75H6.328v4.219Zm0-10.547h37.969v-4.219H6.328v4.219Zm0-14.766v4.219h37.969v-4.219H6.328Z"
                fill="currentColor"
            />
        </G>
    </Svg>
);

export const CallIcon = ({ width = "46", height = "46", ...props }) => (
    <Svg {...props} width={width} height={height}>
        <Defs>
            <Path
                d="M16.55 26.975c3.6 7.075 9.4 12.85 16.475 16.475l5.5-5.5a2.486 2.486 0 0 1 2.55-.6c2.8.925 5.825 1.425 8.925 1.425 1.375 0 2.5 1.125 2.5 2.5V50c0 1.375-1.125 2.5-2.5 2.5C26.525 52.5 7.5 33.475 7.5 10c0-1.375 1.125-2.5 2.5-2.5h8.75c1.375 0 2.5 1.125 2.5 2.5 0 3.125.5 6.125 1.425 8.925.275.875.075 1.85-.625 2.55l-5.5 5.5Z"
                id="a"
            />
        </Defs>
        <G transform="translate(-7 -7)" fill="none" fillRule="evenodd">
            <Path d="M0 0h60v60H0z" />
            <Mask id="b" fill="#fff">
                <Use xlinkHref="#a" />
            </Mask>
            <Path fill="currentColor" mask="url(#b)" d="M0 0h60v60H0z" />
        </G>
    </Svg>
);

export const UnderstandIcon = ({ width = "63", height = "60", ...props }) => (
    <Svg {...props} width={width} height={height}>
        <Path
            d="M61.951 54.356 48.961 41.45l.457-.583c1.762-2.4 3.068-5.06 3.85-7.784h.98c1.11 0 1.958-.844 1.958-1.946 0-1.102-.849-1.946-1.958-1.946h-.13c1.045-7.717-1.502-15.763-7.378-21.663C41.844 2.66 35.316 0 28.398 0c-6.922 0-13.383 2.66-18.28 7.526C5.68 11.937 3.003 17.709 2.612 23.87h-.653C.913 23.87 0 24.715 0 25.75c0 1.102.85 1.946 1.892 2.012h.72a25.12 25.12 0 0 0 7.507 16.15c4.896 4.865 11.424 7.525 18.345 7.525a26.05 26.05 0 0 0 15.211-4.864l.587-.454.13.13 12.926 12.777A3.325 3.325 0 0 0 59.67 60c.912 0 1.762-.324 2.35-.973.654-.649.98-1.492.98-2.336-.069-.841-.395-1.685-1.048-2.334ZM13.057 10.444c4.113-4.087 9.595-6.358 15.34-6.358 5.81 0 11.295 2.27 15.342 6.358 5.093 5.06 7.115 12.066 6.072 18.681h-9.206l-3.72-6.81c-.327-.65-1.046-1.04-1.763-1.04-.719 0-1.435.454-1.698 1.169L28.33 33.666l-4.047-23.027c-.13-.844-.849-1.493-1.698-1.622-.85-.066-1.698.39-2.025 1.168L14.62 24.131l-7.768-.195c.33-5.06 2.484-9.796 6.205-13.492Zm30.746 30.552c-4.113 4.087-9.596 6.357-15.341 6.357-5.81 0-11.294-2.27-15.341-6.357-3.59-3.567-5.81-8.174-6.268-13.168l9.01.258c.782.066 1.565-.453 1.828-1.168l3.85-9.08 4.047 22.702c.13.844.85 1.492 1.698 1.622h.26c.783 0 1.436-.454 1.763-1.169l6.008-13.36 2.414 4.41c.327.65.98 1.04 1.699 1.04h9.466c-1.11 2.853-2.742 5.577-5.093 7.913Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const ProtectIcon = ({ width = "128", height = "128", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 128 128">
        <Path
            d="M64.5 94c-.18-.1-.4-.21-.657-.344a88.756 88.756 0 0 1-11.46-6.933 44.852 44.852 0 0 1-8.295-7.657C41.375 75.709 40 72.453 40 69.389V38.22a56.71 56.71 0 0 0 5.523.271c6.645 0 12.742-2.191 17.641-3.951.231-.094.49-.189.741-.281.232-.085.471-.173.685-.259.237.1.5.195.761.289.226.083.458.168.666.251 5.465 2 11.315 3.958 17.46 4.043 1.883 0 3.741-.091 5.522-.27v31.08C89 81.025 70.247 91.168 64.5 94ZM54.078 61.219l-4.187 4.22 9.532 9.609 21.291-21.555-4.187-4.221-17.1 17.335-5.345-5.388Z"
            fill="currentColor"
        />
    </Svg>
);

export const ReachOutIcon = ({
    width = "298.667",
    height = "285.333",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 214">
        <G fill="currentColor">
            <Path d="M43.4 21.6c-17.7 6.5-23.2 30-10.2 43.5 15.7 16.1 43.2 6.7 45.5-15.7 1.6-15-9.7-28.1-25.1-29-3.8-.2-7.6.2-10.2 1.2zM96.5 24.4c-16.1 3.4-17.1 4-14.6 9.7 1.2 2.4 2.1 5.7 2.1 7.3 0 2.3.3 2.7 1.8 2.1 7.1-3.1 15.6-4.7 25.2-4.7 12.7-.2 20.1 1.6 32 7.4 12 5.8 23.8 17.7 29.8 29.9 2.3 4.7 4.7 11 5.4 14 1.1 5.2 1.3 5.6 5.1 6.8 2.2.6 6 2.6 8.4 4.3l4.5 3-.7-5.8c-1.8-14.5-8.3-30.6-16.9-42.1-18.7-24.8-52.5-38-82.1-31.9z" />
            <Path d="M22.6 75.6c-5.9 2.1-9.8 5.6-13.1 11.5-2.7 4.9-3 6.2-3 15.2 0 14.9-4 13.7 46.1 13.7 49.5 0 45.4 1.2 45.4-13.5 0-10.8-1.3-15.1-6.3-20.4C88.5 78.8 79.9 74 77 74c-.8 0-4.8 1.7-8.8 3.7-6.6 3.3-8.1 3.7-15.6 3.7-7.7.1-8.8-.2-15.7-3.7-8.2-4.1-8.7-4.2-14.3-2.1zM161.4 103.4c-13.1 6.1-19 22.7-12.5 35.4 8.2 16 28.7 20 41.7 8 10.8-10 11.7-26 2-37.5-6.8-8.1-20.8-10.7-31.2-5.9zM29 122.6c0 2.3 3.6 13.8 6 19 13.5 29.9 43.3 49.4 75.7 49.4h10.1l.4-7.8.3-7.7-11.5-.1c-9.8-.1-12.7-.5-19.5-2.8-20.6-7.1-37.5-23.7-43.6-43l-2.4-7.6h-7.7c-4.3 0-7.8.3-7.8.6z" />
            <Path d="M140.2 157.6c-9.5 4.7-13.2 11.9-13.2 25.3 0 7.3.3 9.3 1.9 11.2l1.9 2.4h84.4l2-2.5c1.8-2.2 2-3.6 1.6-12-.3-7.1-.9-10.5-2.5-13.5-4-7.6-12.3-13.5-19.1-13.5-1.6 0-5.5 1.5-8.8 3.2-5.5 3.1-6.6 3.3-15.5 3.3-8.8 0-10.1-.2-15.9-3.3-7.6-3.9-10.1-4-16.8-.6z" />
        </G>
    </Svg>
);

export const TakeCareIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={width} viewBox="0 0 224 215">
        <Path
            d="M54.1 29.6c-16.8 4.5-28.6 18-32.7 37.5-2.5 12-.3 22.4 7.8 38 7.4 14.2 16.2 25.3 35.3 44.4 18.8 18.8 35.3 33.1 43 37.1l5 2.7 4.3-2.2c10.1-5.2 47.2-39.3 62.7-57.6 12.8-15.2 22.5-34.4 24.4-48.2 1.9-13.7-3.2-30.3-12.3-39.7-8.5-8.7-24.3-14.4-36.5-13.2-11.6 1.2-24.5 7.5-37.4 18.1l-5 4.2-7.8-6.1c-17.4-13.8-35.5-19.1-50.8-15zm105.3 37.6 3.8 3.3-30.3 33.8-30.2 33.8-16.4-16.3L70 105.6l3.7-3.8 3.7-3.8 12.1 12c6.6 6.6 12.3 12 12.6 12 .4 0 12.3-13 26.5-29 14.3-15.9 26.2-29 26.5-29 .3 0 2.3 1.5 4.3 3.2z"
            fill="currentColor"
        />
    </Svg>
);

export const MakeaPlanIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="M102.9 7.9c-2.4 2.5-2.9 3.8-2.9 7.9 0 7.3-.7 7.6-18.1 8-10 .3-14.9.8-15.2 1.5-.2.7-.2 4.2.1 7.9l.4 6.8h25.3c13.8 0 33.4-.3 43.3-.7l18.2-.6V32c0-3.8-.5-7.1-1.2-7.8-.8-.8-5.9-1.2-16.4-1.2-17 0-16.4.3-16.4-7.7C120 9.1 116 5 110 5c-3.3 0-4.8.6-7.1 2.9zm8.9 4c.8.4 1.2 1.9 1 3.2-.4 3.4-5.2 3.4-5.6 0-.3-2 1.1-4.1 2.8-4.1.3 0 1.1.4 1.8.9z" />
            <Path d="M162 37.8v8.9l-24.2.6c-13.3.4-36.4.7-51.5.7H59V30h-7c-6.3 0-7.4.3-9.7 2.6l-2.5 2.5.7 82.2c.6 76.5.8 82.4 2.4 84.7l1.8 2.5 64.9.3c35.7.1 65.9 0 67.2-.3 1.2-.3 3.1-1.4 4.2-2.5 2-2 2-3.6 2-66.8 0-35.7-.3-73.1-.7-83.3-.6-17.3-.8-18.4-2.9-20.6-2-2-3.3-2.3-9.9-2.3H162v8.8zm-2.2 65.9-.3 39.8-2.8 6.1c-4.3 9.2-9.1 13.2-28.7 23.8l-17.5 9.5-3.1-1.8c-1.7-1-9.1-5.2-16.3-9.2C72.3 161.4 66.5 155 64 142.1c-.6-3-1-21.3-1-41.7V64h97.1l-.3 39.7z" />
            <Path d="M74 107.3c0 37.6.3 39.1 7.8 45.8 2.6 2.2 10.2 7.1 16.8 10.9l12.1 6.7 14.4-7.8c15.3-8.4 20.5-12.8 22.8-19.6 1-2.7 1.5-12.7 1.8-36.1l.5-32.2H74v32.3zm59.3-6 3.8 3.3-15.5 17.4c-8.6 9.6-16.1 17.6-16.8 17.8-.7.1-5.1-3.9-9.7-8.9l-8.4-9.1 3.6-3.6 3.7-3.6 5.3 5.2 5.3 5.2 11.9-13.5c6.6-7.4 12.2-13.5 12.5-13.5.3.1 2.2 1.5 4.3 3.3z" />
        </G>
    </Svg>
);

export const SafetyOnlineIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="m60 10.5-2.3 2.4.5 94.7.5 94.7 2.7 2.4 2.7 2.3h96.1l2.8-2.8 2.8-2.8-.5-93c-.3-58-.8-93.9-1.4-95.5-.6-1.5-2.2-3.1-3.5-3.8-1.7-.8-16.9-1.1-50.3-1.1H62.3L60 10.5zm54.4 2.7c.8 1.4.7 2.1-.6 3.4-3 3-7.5-.9-4.8-4.2 1.6-1.8 3.9-1.5 5.4.8zm40 14 2.4 2.3.7 72.5.7 72.5-2.2 2.8-2.2 2.7-42-.2-42.1-.3-1.8-2.5c-1.7-2.4-1.8-6.7-2-75.4l-.2-72.9 2.2-1.9c2.2-1.7 5-1.8 43.2-1.8h40.8l2.5 2.2zm-37.1 161c4.1 4.8.7 11.8-5.8 11.8-4.1 0-7.5-3.2-7.5-7 0-6.9 8.8-10.2 13.3-4.8z" />
            <Path d="M117 100.4c-6.7 7.5-12.5 13.6-12.8 13.6-.4 0-2.9-2.3-5.7-5l-5.1-5-3.2 3.3-3.2 3.3 8.8 8.7 8.8 8.8 15.7-17.4 15.6-17.4-3.3-3.2-3.4-3.3-12.2 13.6z" />
        </G>
    </Svg>
);

export const EndingRelationshipIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="M54.1 29.6C29.2 36.3 14.4 65.5 23 91c2.7 8.1 9.6 21.4 15.4 29.4 6.8 9.4 24 28 38.2 41.1 21 19.3 32.3 27.6 36.7 27 2.6-.5 10.9-5.5 10.5-6.5-.2-.5-5.9-6.1-12.8-12.6s-12.6-12.1-12.8-12.5c-.2-.5 6-6.8 24.1-24l6.8-6.4-15.5-14.5c-8.5-8-15.4-15-15.3-15.5.1-.6 7.1-7.6 15.6-15.5l15.3-14.5-9.3-8.8C101.6 40.5 88.6 32.3 75 29.4c-8.2-1.7-14-1.7-20.9.2z" />
            <Path d="M150.4 29c-6.5 1.3-15.9 5.5-23.5 10.5l-7 4.7 11.7 11.2 11.7 11.1-15.8 15-15.7 14.9 15.7 15.1 15.8 15-15.8 15-15.7 15 10.2 9.8 10.2 9.7 6.1-5.2c10.6-9 38.9-38 44.9-45.8 11.5-15.3 18.7-30.3 20.8-43.7 2.1-12.8-3.6-30.9-12.3-39.7-10.1-10-27.4-15.3-41.3-12.6z" />
        </G>
    </Svg>
);

export const PlanSafetyIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="M102.9 7.9c-2.4 2.5-2.9 3.8-2.9 7.9 0 7.3-.7 7.6-18.1 8-10 .3-14.9.8-15.2 1.5-.2.7-.2 4.2.1 7.9l.4 6.8h25.3c13.8 0 33.4-.3 43.3-.7l18.2-.6V32c0-3.8-.5-7.1-1.2-7.8-.8-.8-5.9-1.2-16.4-1.2-17 0-16.4.3-16.4-7.7C120 9.1 116 5 110 5c-3.3 0-4.8.6-7.1 2.9zm8.9 4c.8.4 1.2 1.9 1 3.2-.4 3.4-5.2 3.4-5.6 0-.3-2 1.1-4.1 2.8-4.1.3 0 1.1.4 1.8.9z" />
            <Path d="M162 37.8v8.9l-24.2.6c-13.3.4-36.4.7-51.5.7H59V30h-7c-6.3 0-7.4.3-9.7 2.6l-2.5 2.5.7 82.2c.6 76.5.8 82.4 2.4 84.7l1.8 2.5 64.9.3c35.7.1 65.9 0 67.2-.3 1.2-.3 3.1-1.4 4.2-2.5 2-2 2-3.6 2-66.8 0-35.7-.3-73.1-.7-83.3-.6-17.3-.8-18.4-2.9-20.6-2-2-3.3-2.3-9.9-2.3H162v8.8zm-2.2 65.9-.3 39.8-2.8 6.1c-4.3 9.2-9.1 13.2-28.7 23.8l-17.5 9.5-3.1-1.8c-1.7-1-9.1-5.2-16.3-9.2C72.3 161.4 66.5 155 64 142.1c-.6-3-1-21.3-1-41.7V64h97.1l-.3 39.7z" />
            <Path d="M74 107.3c0 37.6.3 39.1 7.8 45.8 2.6 2.2 10.2 7.1 16.8 10.9l12.1 6.7 14.4-7.8c15.3-8.4 20.5-12.8 22.8-19.6 1-2.7 1.5-12.7 1.8-36.1l.5-32.2H74v32.3zm59.3-6 3.8 3.3-15.5 17.4c-8.6 9.6-16.1 17.6-16.8 17.8-.7.1-5.1-3.9-9.7-8.9l-8.4-9.1 3.6-3.6 3.7-3.6 5.3 5.2 5.3 5.2 11.9-13.5c6.6-7.4 12.2-13.5 12.5-13.5.3.1 2.2 1.5 4.3 3.3z" />
        </G>
    </Svg>
);

export const PregnantIcon = ({
    width = "297.333",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 223 215">
        <Path
            d="m110.9 6.9-2.4 1.9-.5 33.4-.5 33.3-2.6.3c-1.4.2-3-.3-3.6-1-1.2-1.5-3-20.5-3.9-42.6C96.6 15 95.5 12 90 12c-4.3 0-5.9.9-7.7 4.3-1.7 3.3-1.5 15 .8 42.2l1.1 13 5.6 7.3C96.7 87.9 100.3 91 104 91c3.2 0 31.9 8.7 33.8 10.2.6.6 1.2 2.1 1.2 3.4 0 3.7-3.9 5.1-9.7 3.6-2.5-.7-4.8-1.1-5-.8-.2.2 2.4 3.7 5.9 7.7 14.9 17.1 15.6 18.2 12.3 20.9-2.3 1.9-5 .3-11-6.6-3.2-3.6-6-6.3-6.2-6-.3.3 2.5 4.4 6.2 9.2 3.6 4.7 6.9 9.2 7.1 9.8.3.7-.3 2.3-1.4 3.6-2.6 3.2-4.7 1.8-12.9-8.7-8.1-10.3-9.7-9.7-1.8.8 5.8 7.9 7.1 12.3 3.6 13.4-3.1.9-4.6-.3-11.5-9.6-3.6-4.9-7.1-8.9-7.7-8.9-1.1 0-.4 1.3 4.8 9 3.2 4.7 3.1 8.8-.2 9.6-3.2.8-4.2-.1-10.6-9.4C98 138 93.8 132 91.5 129c-5.7-7.4-7.5-11.2-9.7-19.9-1.5-6.1-3-8.9-8.4-16.2C64.8 81.3 62 79 56.6 79c-2.3 0-5.2.7-6.5 1.6-2 1.5-2.3 2.3-1.9 6.3.4 3.8 3.1 8.9 15.3 28.6 8.2 13.2 16.9 27.8 19.5 32.5 2.5 4.7 5.6 10.1 6.8 12 4.7 7.8 5.4 11.6 5.3 28.1-.2 18.9-.3 18.8 9.7 17.1 13.3-2.3 16.8-2.4 28.1-.7 12.7 1.9 15.6 1.5 16.5-1.7.3-1.3.6-9.4.6-18.1 0-17.6 1-22 7.3-32.4 2-3.2 4.8-9.4 6.3-13.8 2.4-7 2.8-10.2 3.4-26 .5-11.4 1.5-21.7 2.8-28 2.8-13.7 5.2-33.2 5.2-42.1 0-8.7-1.8-11.4-7.3-11.4-5.4 0-7.4 3.1-8.2 12.5-.9 11.8-3.6 31.7-4.6 34.2-.9 2.6-5 3.2-6.7 1-.6-.8-.7-6.3-.2-16.2.5-8.3.9-22.6.9-31.8.1-16.5.1-16.8-2.4-19.2-3.1-3.2-6.6-3.2-10.2-.1l-2.8 2.4-.7 30.2c-.5 21.3-1 30.6-1.9 31.6-.7.8-2.4 1.4-3.8 1.2l-2.6-.3-.5-33.8-.5-33.9-2.4-1.9c-3-2.4-7.2-2.4-10.2 0z"
            fill="currentColor"
        />
    </Svg>
);

export const TakeCareHealthIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <Path
            d="M54.1 29.6c-16.8 4.5-28.6 18-32.7 37.5-2.5 12-.3 22.4 7.8 38 7.4 14.2 16.2 25.3 35.3 44.4 18.8 18.8 35.3 33.1 43 37.1l5 2.7 4.3-2.2c10.1-5.2 47.2-39.3 62.7-57.6 12.8-15.2 22.5-34.4 24.4-48.2 1.9-13.7-3.2-30.3-12.3-39.7-8.5-8.7-24.3-14.4-36.5-13.2-11.6 1.2-24.5 7.5-37.4 18.1l-5 4.2-7.8-6.1c-17.4-13.8-35.5-19.1-50.8-15zm105.3 37.6 3.8 3.3-30.3 33.8-30.2 33.8-16.4-16.3L70 105.6l3.7-3.8 3.7-3.8 12.1 12c6.6 6.6 12.3 12 12.6 12 .4 0 12.3-13 26.5-29 14.3-15.9 26.2-29 26.5-29 .3 0 2.3 1.5 4.3 3.2z"
            fill="currentColor"
        />
    </Svg>
);

export const HealthierRelationshipIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="M60.1 48.5c-6.9 2-10.8 4.4-16.1 10.1-6.3 6.9-8.5 12.4-8.5 21.9 0 6.6.5 9 2.6 13.6 3.6 7.6 9 13.3 15.7 16.6 5 2.4 6.9 2.8 14.7 2.8 7.8 0 9.7-.4 14.7-2.8 6.7-3.3 12.1-9 15.7-16.6 3.8-8.2 3.7-19.3-.2-27.3-7.1-14.5-23.8-22.4-38.6-18.3zM147.7 48c-9.4 2.4-17.6 9-22.4 18.2-2.4 4.6-2.8 6.4-2.8 14.3 0 7.8.4 9.7 2.8 14.7 3.5 7.2 11 14 18.5 16.8 11.7 4.5 26 1.3 35-7.8 13.4-13.4 13-34.6-.9-47.9-7.2-6.8-21-10.6-30.2-8.3zM30.3 117.1c-6.4 2.5-13.7 9.4-16.6 15.7-1.7 3.8-2.2 7.1-2.5 16.9-.4 12-.4 12.2 2.2 14.7l2.5 2.6H126.2l-.4-14.8c-.4-17.2-1.7-21.3-9.3-28.6-4.5-4.4-13.2-8.6-17.8-8.6-1.2 0-6 1.9-10.6 4.2l-8.4 4.3H57.3l-8.4-4.3c-9.4-4.7-11.2-4.9-18.6-2.1zM125.9 119.7c7.5 8.9 8.5 12.6 8.9 31l.4 16.3h36.2c35 0 36.3-.1 38.4-2 3-2.9 3.5-5.7 3-17.3-.4-8.5-.9-11.1-3.1-15.4-4.6-8.9-13.2-15.5-22.1-17-2.9-.5-5.2.2-12.1 3.8-8 4-9.3 4.3-17.9 4.7-10.5.5-18.9-1.6-25.8-6.3-2-1.4-5.1-2.5-6.8-2.5h-3.1l4 4.7z" />
        </G>
    </Svg>
);

export const TakeCareOfMyHealthIcon = ({
    width = "188",
    height = "159",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 188 159"
        fill="none">
        <Path
            d="M162.256 39.564H25.546A25.533 25.533 0 0 0 0 65.099v68.3A25.533 25.533 0 0 0 25.546 159h136.71a25.55 25.55 0 0 0 18.112-7.479 25.541 25.541 0 0 0 7.479-18.111v-68.3a25.546 25.546 0 0 0-7.495-18.083 25.534 25.534 0 0 0-18.096-7.463Zm-43.811 64.675h-15.797v15.775a8.743 8.743 0 0 1-8.747 8.747 8.748 8.748 0 0 1-8.746-8.747v-15.775H69.368a8.744 8.744 0 0 1-8.746-8.747 8.746 8.746 0 0 1 8.746-8.746h15.787V70.959a8.747 8.747 0 0 1 17.493 0v15.787h15.797a8.746 8.746 0 1 1 0 17.493Z"
            fill="currentColor"
        />
        <Path
            d="M50.068 7h87.633A18.2 18.2 0 0 1 155.9 25.199v23.794H31.87V25.2A18.199 18.199 0 0 1 50.068 7Z"
            stroke="currentColor"
            strokeWidth={13.16}
            strokeMiterlimit={10}
        />
    </Svg>
);

export const WellBeingIcon = ({ width = "188", height = "190", ...props }) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 188 190"
        fill="none">
        <Path
            d="M84.17 1.02c-6.03 2.048-9.436 4.084-13.327 7.976-10.182 10.318-9.922 24.72.87 34.652 6.913 6.324 11.88 8.168 22.197 8.168 7.489-.09 9.537-.486 14.3-2.726 13.825-6.709 19.662-21.495 13.429-33.668-2.331-4.763-8.859-10.51-14.493-13.044C101.513-.156 89.724-.756 84.17 1.02Z"
            fill="currentColor"
        />
        <Path
            d="M186.847 31.962c-1.946-4.673-8.179-8.372-14.119-8.372-5.939 0-10.023 2.262-23.938 12.942-20.827 16.065-22.773 17.332-31.62 20.25-8.18 2.625-9.537 2.817-25.206 2.817-24.04 0-26.959-1.267-52.459-22.286-14.99-12.354-21.89-15.443-29.482-13.18C5.442 25.49 0 31.238 0 34.643c0 4.186 2.817 7.002 19.368 19.458C41.994 71.14 46.124 74.838 48.782 80.19l2.342 4.673.237 47.628c.385 52.357.283 51.576 6.325 54.789 1.753.871 6.324 1.754 10.702 2.048 8.564.486 14.401-1.132 18.293-5.261 2.342-2.432 2.342-2.726 2.828-27.445.283-13.723.871-25.591 1.256-26.269 1.267-1.856 5.362-1.369 6.528.678.577 1.132.973 11.189.973 25.794v23.758l2.624 3.213c3.598 4.186 7.693 5.747 15.477 5.747 8.564 0 13.575-1.561 16.833-5.453 2.817-3.111 2.817-3.111 3.508-21.495.384-10.023.486-31.145.192-46.904-.487-19.956-.294-29.98.486-32.99 1.358-5.452 6.709-10.996 18.78-19.47 27.762-19.39 33.306-25.035 30.681-31.268ZM115.993 85.63c-.475 3.869-2.873 8.473-6.788 12.965a100.817 100.817 0 0 1-13.575 12.602c-1.652 1.132-2.353 1.132-4.265-.294a102.112 102.112 0 0 1-15.126-14.707 25.714 25.714 0 0 1-4.604-9.48c-1.064-6.075 2.737-12.162 8.36-13.35 3.518-.724 7.998.736 11.924 3.836l1.821 1.448 1.788-1.448c3.824-3.055 7.727-4.413 11.098-3.835a10.67 10.67 0 0 1 8.021 5.656 14.518 14.518 0 0 1 1.346 6.607Z"
            fill="currentColor"
        />
    </Svg>
);

export const TakeCareOfYourselfIcon = ({
    width = "188",
    height = "190",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 188 190"
        fill="none">
        <Path
            d="M84.17 1.02c-6.03 2.048-9.436 4.084-13.327 7.976-10.182 10.318-9.922 24.72.87 34.652 6.913 6.324 11.88 8.168 22.197 8.168 7.489-.09 9.537-.486 14.3-2.726 13.825-6.709 19.662-21.495 13.429-33.668-2.331-4.763-8.859-10.51-14.493-13.044C101.513-.156 89.724-.756 84.17 1.02Z"
            fill="currentColor"
        />
        <Path
            d="M186.847 31.962c-1.946-4.673-8.179-8.372-14.119-8.372-5.939 0-10.023 2.262-23.938 12.942-20.827 16.065-22.773 17.332-31.62 20.25-8.18 2.625-9.537 2.817-25.206 2.817-24.04 0-26.959-1.267-52.459-22.286-14.99-12.354-21.89-15.443-29.482-13.18C5.442 25.49 0 31.238 0 34.643c0 4.186 2.817 7.002 19.368 19.458C41.994 71.14 46.124 74.838 48.782 80.19l2.342 4.673.237 47.628c.385 52.357.283 51.576 6.325 54.789 1.753.871 6.324 1.754 10.702 2.048 8.564.486 14.401-1.132 18.293-5.261 2.342-2.432 2.342-2.726 2.828-27.445.283-13.723.871-25.591 1.256-26.269 1.267-1.856 5.362-1.369 6.528.678.577 1.132.973 11.189.973 25.794v23.758l2.624 3.213c3.598 4.186 7.693 5.747 15.477 5.747 8.564 0 13.575-1.561 16.833-5.453 2.817-3.111 2.817-3.111 3.508-21.495.384-10.023.486-31.145.192-46.904-.487-19.956-.294-29.98.486-32.99 1.358-5.452 6.709-10.996 18.78-19.47 27.762-19.39 33.306-25.035 30.681-31.268ZM115.993 85.63c-.475 3.869-2.873 8.473-6.788 12.965a100.817 100.817 0 0 1-13.575 12.602c-1.652 1.132-2.353 1.132-4.265-.294a102.112 102.112 0 0 1-15.126-14.707 25.714 25.714 0 0 1-4.604-9.48c-1.064-6.075 2.737-12.162 8.36-13.35 3.518-.724 7.998.736 11.924 3.836l1.821 1.448 1.788-1.448c3.824-3.055 7.727-4.413 11.098-3.835a10.67 10.67 0 0 1 8.021 5.656 14.518 14.518 0 0 1 1.346 6.607Z"
            fill="currentColor"
        />
    </Svg>
);

export const GetLegalHelpIcon = ({
    width = "200",
    height = "190",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 200 190"
        fill="none">
        <Path
            d="M13.48.277A5.689 5.689 0 0 0 7.79 5.98v7.495h-.445a7.347 7.347 0 0 0 0 14.693h.445v7.494a5.702 5.702 0 0 0 11.39 0V6.006A5.69 5.69 0 0 0 13.48.277Zm178.296 13.197h-.431V5.979a5.699 5.699 0 0 0-1.567-4.21A5.694 5.694 0 0 0 185.649 0a5.695 5.695 0 0 0-4.128 1.77 5.699 5.699 0 0 0-1.567 4.21v29.655a5.703 5.703 0 0 0 11.391 0V28.14h.431a7.348 7.348 0 0 0 5.195-12.541 7.348 7.348 0 0 0-5.195-2.152v.027Zm-16.661-7.522H24.007a1.995 1.995 0 0 0-1.927 2.063v25.611a2.008 2.008 0 0 0 1.927 2.062h151.108a2.01 2.01 0 0 0 1.941-2.062V8.015a1.992 1.992 0 0 0-1.941-2.076v.013Zm-3.72 33.416H27.755a5.661 5.661 0 0 0-5.662 5.662v139.124a5.666 5.666 0 0 0 3.495 5.231 5.67 5.67 0 0 0 2.167.43h143.64a5.67 5.67 0 0 0 2.166-.43 5.67 5.67 0 0 0 3.064-3.064 5.657 5.657 0 0 0 .431-2.167V44.963a5.662 5.662 0 0 0-5.661-5.595Zm-66.051 108.337a7.904 7.904 0 0 1-5.796 4.583l-.701.135H97.39c-.431-.081-.863-.149-1.267-.256a7.917 7.917 0 0 1-5.891-6.881 7.912 7.912 0 1 1 15.111 2.419Zm17.052-47.179a17.667 17.667 0 0 1-4.152 7.009 46.4 46.4 0 0 1-7.117 5.864c-1.429.984-2.696 2.008-4.044 3.033a8.546 8.546 0 0 0-2.629 3.815c-.283.768-.62 1.523-.916 2.305a5.394 5.394 0 0 1-1.928 2.534 5.396 5.396 0 0 1-3.033.984 6.918 6.918 0 0 1-3.612-.566 5.892 5.892 0 0 1-3.236-4.408 10.124 10.124 0 0 1 1.712-7.562 21.02 21.02 0 0 1 4.476-4.732c1.873-1.523 3.787-2.979 5.715-4.502a15.442 15.442 0 0 0 3.896-4.462 8.357 8.357 0 0 0-.998-9.274 7.668 7.668 0 0 0-4.286-2.359 13.373 13.373 0 0 0-6.646.108 8.086 8.086 0 0 0-5.136 4.273c-.674 1.254-1.253 2.548-1.887 3.815a9.15 9.15 0 0 1-1.833 2.575 6.395 6.395 0 0 1-4.84 1.55 6.62 6.62 0 0 1-3.06-.822 5.257 5.257 0 0 1-2.075-1.955 5.189 5.189 0 0 1-.768-2.696 13.91 13.91 0 0 1 2.844-8.735 22.038 22.038 0 0 1 8.573-6.928 25.756 25.756 0 0 1 8.088-2.332l1.604-.162h3.1l1.55.148a29.922 29.922 0 0 1 10.986 2.858 18.26 18.26 0 0 1 7.589 6.484 16.817 16.817 0 0 1 2.589 7.386c.29 2.23.12 4.497-.499 6.659l-.027.095Z"
            fill="currentColor"
        />
    </Svg>
);

export const TalkingToYourFriendIcon = ({
    width = "176",
    height = "199",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 176 199"
        fill="none">
        <Path
            d="M105.859 0H42.551a13.374 13.374 0 0 0-9.443 3.896 13.311 13.311 0 0 0-3.913 9.418V79.07l15.198-13.92h61.466a13.373 13.373 0 0 0 9.443-3.896 13.29 13.29 0 0 0 3.912-9.418V13.314a13.29 13.29 0 0 0-3.912-9.418A13.348 13.348 0 0 0 105.859 0ZM91.377 27.204c-.373 2.982-2.224 6.53-5.242 9.98a76.883 76.883 0 0 1-10.465 9.707c-1.274.88-1.823.84-3.302-.225a78.793 78.793 0 0 1-11.67-11.32 20 20 0 0 1-3.557-7.291c-.814-4.683 2.116-9.365 6.457-10.284 2.714-.557 6.173.557 9.2 2.933l1.412 1.124 1.381-1.124c2.94-2.356 5.958-3.402 8.564-2.933a8.252 8.252 0 0 1 3.627 1.423 8.225 8.225 0 0 1 2.566 2.927 11.393 11.393 0 0 1 1.029 5.083ZM175.999 180.026a2.023 2.023 0 0 1-.574 1.459 2.024 2.024 0 0 1-1.445.609h-61.882c-.523-14.805-2.433-21.228-11.265-29.67a42.453 42.453 0 0 0-11.872-7.773 24.537 24.537 0 0 1 6.848-4.307c6.18-2.335 7.689-2.177 15.559 1.752l7.031 3.65h18.746l7.031-3.65c3.832-1.922 7.859-3.515 8.856-3.515 3.857 0 11.131 3.515 14.902 7.201 6.35 6.082 7.445 9.537 7.786 23.928l.279 10.316ZM115.468 134.992c4.184 2.007 5.778 2.335 12.298 2.335 6.521 0 8.114-.328 12.299-2.335a28.714 28.714 0 0 0 13.138-13.892 28.202 28.202 0 0 0-.158-22.846c-5.949-12.164-19.926-18.745-32.298-15.315-5.778 1.679-9.038 3.65-13.478 8.515-5.268 5.779-7.117 10.377-7.117 18.32 0 5.523.426 7.53 2.178 11.387a28.753 28.753 0 0 0 13.138 13.831Z"
            fill="currentColor"
        />
        <Path
            d="M91.673 185.403c0-1.217 0-2.299-.085-3.309-.377-10.498-1.313-11.386-5.024-14.951a23.024 23.024 0 0 0-6.556-4.038 12.844 12.844 0 0 0-1.485-.548c-1.216.463-3.223 1.314-5.51 2.433l-9.574 4.866H38.587l-9.66-4.951a35.14 35.14 0 0 0-5.327-2.36c-.989.246-1.957.567-2.896.961a20.685 20.685 0 0 0-9.062 8.649c-.62 1.375-1.046 2.701-1.29 11.046 0 1.35-.073 3.065-.097 4.793h81.504l-.086-2.591Zm-27.905-38.684-5.268 2.7H43.538l-5.353-2.749a61.983 61.983 0 0 0-7.019-3.114 27.896 27.896 0 0 0 6.788 4.732c4.44 2.129 6.082 2.433 13.053 2.433 6.97 0 8.637-.365 13.065-2.433a27.871 27.871 0 0 0 6.812-4.768c-1.861.705-4.197 1.739-7.116 3.199Zm38.16 38.453c0-1.083 0-2.117-.097-3.078-.45-12.749-1.898-16.313-8.175-22.335a32.846 32.846 0 0 0-11.495-6.775 14.16 14.16 0 0 0-4.307-.864c-.55.055-1.089.182-1.605.377a37.498 37.498 0 0 1-7.628 4.975c-6.374 3.054-9.804 3.54-17.602 3.54s-11.204-.486-17.493-3.491h-.085a36.794 36.794 0 0 1-7.457-4.866c-2.847-.669-5-.121-8.905 1.351a30.71 30.71 0 0 0-14.743 13.94C.827 171.328.377 174.248.11 182.97c-.159 4.647-.098 13.223-.098 13.223a2.143 2.143 0 0 0 2.153 2.141h97.939a2.143 2.143 0 0 0 1.535-.644 2.148 2.148 0 0 0 .618-1.546l-.329-10.972Z"
            fill="#FFFDF5"
        />
        <Path
            d="M102.232 196.12a2.148 2.148 0 0 1-1.32 2.022 2.147 2.147 0 0 1-.833.167H2.153a2.13 2.13 0 0 1-1.522-.622A2.147 2.147 0 0 1 0 196.168s0-8.576.097-13.223c.268-8.722.718-11.641 2.227-15.023a30.717 30.717 0 0 1 14.743-13.941c3.905-1.472 6.083-2.019 8.905-1.35a36.881 36.881 0 0 0 7.457 4.866h.085c6.29 3.004 9.732 3.491 17.493 3.491 7.76 0 11.228-.487 17.602-3.54a37.585 37.585 0 0 0 7.627-4.975 6.333 6.333 0 0 1 1.606-.377c1.472.062 2.925.353 4.306.863a32.849 32.849 0 0 1 11.496 6.776c6.277 6.082 7.725 9.586 8.175 22.334 0 .962.073 1.995.097 3.078l.316 10.973Z"
            fill="currentColor"
        />
        <Path
            d="M77.854 109.276C71.541 96.393 56.7 89.374 43.55 93.024c-6.083 1.776-9.598 3.917-14.306 8.965-5.596 6.082-7.554 11.021-7.554 19.464 0 5.875.45 7.992 2.311 12.079a32.709 32.709 0 0 0 7.165 10.024 27.895 27.895 0 0 0 6.788 4.732c4.44 2.129 6.082 2.433 13.053 2.433 6.97 0 8.637-.365 13.065-2.433a27.873 27.873 0 0 0 6.812-4.768 32.702 32.702 0 0 0 7.14-9.988 29.958 29.958 0 0 0-.17-24.256Zm-41.092-.292c3.576-3.869 5.547-4.866 9.586-6.083 8.393-2.286 18.174 2.433 22.285 10.949a19.828 19.828 0 0 1 .134 15.376 20.462 20.462 0 0 1-9.123 9.89c-2.847 1.362-3.078 1.484-8.637 1.484-5.56 0-5.766-.122-8.515-1.448a20.59 20.59 0 0 1-9.148-9.865c-1.083-2.433-1.35-3.005-1.35-7.761-.013-5.876.912-8.321 4.768-12.542Z"
            fill="#FFFDF5"
        />
        <Path
            d="M78.025 133.532a32.702 32.702 0 0 1-7.141 9.988 27.873 27.873 0 0 1-6.812 4.768c-4.428 2.129-6.083 2.433-13.065 2.433-6.983 0-8.613-.365-13.053-2.433a27.895 27.895 0 0 1-6.788-4.732 32.709 32.709 0 0 1-7.165-10.024c-1.861-4.087-2.311-6.204-2.311-12.079 0-8.443 1.958-13.382 7.554-19.464 4.708-5.048 8.175-7.19 14.306-8.965 13.15-3.65 27.979 3.37 34.304 16.252a29.962 29.962 0 0 1 .17 24.256Z"
            fill="currentColor"
        />
    </Svg>
);

export const LegalIcon = ({ width = "60", height = "60", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 60 60">
        <Path
            d="m33.605 29.663-8.977 9.75c2.625 3 .637 5.418-2.01 7.897-3.544 3.315-6.87 6.866-10.339 10.264-2.692 2.625-4.147 2.625-6.829.06-7.222-6.893-7.222-6.893-.266-13.875l7.444-7.455c3.349-3.345 3.686-3.409 7.743-1.395l8.967-9.297c-1.875-1.593-2.678-4.875-6.848-3.42-1.102.376-3.641-2.2-4.901-3.885-.502-.67.274-2.958 1.125-3.884 4.095-4.37 8.422-8.528 12.671-12.75C32.705.355 34.228-.83 35.938.768c1.71 1.597 4.342 2.786 3.195 6.037a3 3 0 0 0 .375 2.558c3.75 3.967 7.657 7.803 11.464 11.625 3.404-1.804 4.706-1.399 7.364 2.002 1.876 2.419.312 3.941-1.297 5.532-3.821 3.78-7.612 7.586-11.422 11.377-1.538 1.534-2.967 3.416-5.483 1.523-3.397-2.558-3.855-3.95-2.295-7.084l-4.234-4.676Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const ChildrenIcon = ({
    width = "298.667",
    height = "286.667",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 224 215">
        <G fill="currentColor">
            <Path d="M102.5 11.3c-6.2 2.1-9.7 4.2-13.7 8.2-10.5 10.6-10.2 25.4.9 35.6 7.1 6.5 12.2 8.4 22.8 8.4 7.7-.1 9.8-.5 14.7-2.8 14.2-6.9 20.2-22.1 13.8-34.6-2.4-4.9-9.1-10.8-14.9-13.4-5.7-2.5-17.9-3.2-23.6-1.4z" />
            <Path d="M26.3 35.1C21.6 36.5 16 42.4 16 45.9c0 4.3 2.9 7.2 19.9 20 23.2 17.5 27.5 21.3 30.2 26.8l2.4 4.8.3 48.9c.4 53.8.3 53 6.5 56.3 1.8.9 6.5 1.8 11 2.1 8.8.5 14.8-1.2 18.8-5.4 2.4-2.5 2.4-2.8 2.9-28.2.3-14.1.9-26.3 1.3-27 1.3-1.9 5.5-1.4 6.7.7.6 1.2 1 11.5 1 26.5v24.4l2.7 3.3c3.7 4.3 7.9 5.9 15.9 5.9 8.8 0 13.9-1.6 17.3-5.6 2.9-3.2 2.9-3.2 3.6-22.1.4-10.3.5-32 .2-48.2-.5-20.5-.3-30.8.5-33.9 1.4-5.6 6.9-11.3 19.3-20C205 55.3 210.7 49.5 208 43.1c-2-4.8-8.4-8.6-14.5-8.6-6.2.1-10.3 2.3-24.6 13.3-21.4 16.5-23.4 17.8-32.5 20.8-8.4 2.7-9.8 2.9-25.9 2.9-24.7 0-27.7-1.3-53.9-22.9-15.4-12.7-22.5-15.9-30.3-13.5z" />
        </G>
    </Svg>
);

export const OfferSupportIcon = ({
    width = "128",
    height = "128",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 128 128">
        <Path
            d="M92.708 38.293A21.354 21.354 0 0 0 77.514 32h-.003a21.322 21.322 0 0 0-13.515 4.783c-8.482-6.882-20.904-6.295-28.712 1.51-8.346 8.349-8.38 21.914-.093 30.299.027.036.057.069.087.099l24.905 24.9a5.384 5.384 0 0 0 3.812 1.575c1.38 0 2.76-.526 3.81-1.575a5.365 5.365 0 0 0 1.539-4.459c.213.025.427.043.643.043a5.36 5.36 0 0 0 3.807-1.576 5.344 5.344 0 0 0 1.539-4.45c.21.025.424.043.64.043h.003c1.437 0 2.79-.563 3.807-1.579a5.386 5.386 0 0 0 1.53-4.452 5.36 5.36 0 0 0 4.459-1.536l6.938-6.934c.03-.03.058-.06.085-.093A21.359 21.359 0 0 0 99 53.49a21.34 21.34 0 0 0-6.293-15.197h.001ZM79.786 73.992 67.475 61.68a1.154 1.154 0 1 0-1.633 1.633L78.151 75.62a3.087 3.087 0 0 1 0 4.357 3.055 3.055 0 0 1-2.174.902h-.003c-.82 0-1.596-.322-2.177-.905h-.003L61.49 67.672a1.154 1.154 0 1 0-1.633 1.633l12.309 12.308c.583.584.902 1.356.902 2.18a3.08 3.08 0 0 1-5.258 2.174L55.503 73.66a1.154 1.154 0 1 0-1.632 1.633l12.308 12.308c.58.58.902 1.353.902 2.174 0 .824-.322 1.6-.905 2.183a3.09 3.09 0 0 1-4.36 0L37.008 67.155a1.282 1.282 0 0 0-.084-.096c-7.48-7.48-7.483-19.65-.003-27.134 6.882-6.879 17.772-7.456 25.33-1.56-.974.974-13.154 13.15-15.24 15.24-1.455 1.452-1.308 3.55.363 5.222 2.198 2.198 7.255 3.647 11.134-.225l5.838-5.842c2.093 1.882 4.29 3.073 6.431 3.503l13.37 13.366a3.087 3.087 0 0 1 .003 4.357 3.061 3.061 0 0 1-2.18.905 3.047 3.047 0 0 1-2.182-.9Zm11.29-6.933a1.22 1.22 0 0 0-.081.09l-3.732 3.728a5.343 5.343 0 0 0-1.49-2.871L74.076 56.305c1.804-.331 3.494-1.242 4.979-2.727a1.154 1.154 0 1 0-1.633-1.63c-1.701 1.705-3.634 2.427-5.739 2.14-2.11-.282-4.374-1.58-6.548-3.751-.433-.433-1.2-.433-1.633 0l-6.632 6.635a5.585 5.585 0 0 1-7.868.226c-.53-.53-1.022-1.3-.364-1.96l15.31-15.31a19.05 19.05 0 0 1 13.562-5.62h.003c5.123 0 9.94 1.994 13.562 5.617a19.07 19.07 0 0 1 5.619 13.568c0 5.123-1.996 9.943-5.62 13.566Z"
            stroke="#E86451"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const StayingSafeIcon = ({ width = "60", height = "56", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 60 56">
        <Path
            d="M29.996 48.83a2.657 2.657 0 0 1-2.551-2.756 2.648 2.648 0 0 1 2.75-2.552 2.652 2.652 0 0 1 2.557 2.651 2.68 2.68 0 0 1-2.708 2.656h-.048Zm2.539-27.188-.52 17.605h-4.04l-.522-17.605h5.082ZM26.086 2.288.531 48.928a4.39 4.39 0 0 0 3.906 6.48h51.132a4.396 4.396 0 0 0 3.906-6.48L33.91 2.289a4.478 4.478 0 0 0-7.812 0h-.013Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const HealthIcon = ({ width = "58", height = "53", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 58 53">
        <Path
            d="M57.713 16.387a21.525 21.525 0 0 1-3.87 11.935 93.649 93.649 0 0 1-22.785 23.67 2.962 2.962 0 0 1-4.105.115A91.728 91.728 0 0 1 4.078 28.532a20.134 20.134 0 0 1-3.796-15.5A15.78 15.78 0 0 1 11.547.692a14.872 14.872 0 0 1 15.5 4.255c1.5 1.46 2.21 1.625 3.74.055a15.178 15.178 0 0 1 17.5-3.66 16.248 16.248 0 0 1 9.426 15.045"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const SelfCareIcon = ({ width = "60", height = "54", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 60 54">
        <Path
            d="M29.73 12.251c7.579 6.654 14.962 13.109 22.282 19.64.616.644.973 1.49.998 2.38.085 5.464 0 10.933.066 16.396.026 2.18-.947 2.893-3.038 2.883-13.525-.053-27.05-.053-40.575 0-2.347 0-3.054-.893-3.007-3.13.11-5.276 0-10.56.076-15.84a4.059 4.059 0 0 1 .878-2.721c7.31-6.518 14.713-12.95 22.32-19.608Zm13.484-1.563V6.763c0-.632-.177-1.487.152-1.895 2.138-2.693 5.116-.875 7.696-1.156.562-.06 1.815 1.466 1.87 2.318.22 3.42.24 6.853.06 10.276a5.365 5.365 0 0 0 2.364 5.217c.73.572 1.421 1.184 2.078 1.838 2.754 2.431 2.729 2.905.357 5.491-1.393 1.523-2.479 1.4-3.954.083-7.111-6.357-14.35-12.572-21.407-18.986-1.977-1.797-3.316-1.964-5.368-.094-6.913 6.296-14.034 12.363-20.978 18.631-1.895 1.696-3.158 2.012-4.983-.136-1.747-2.04-1.295-3.218.514-4.79C9.655 16.578 17.604 9.49 25.596 2.452c3.474-3.047 4.661-3.047 8.075-.075 3 2.586 5.972 5.185 9.543 8.311ZM29.73 31.155l-.906-.711a6.36 6.36 0 0 0-9.187.035 6.457 6.457 0 0 0 .484 9.117c.037.034.075.066.116.1 2.558 2.675 5.249 5.224 7.829 7.88 1.004 1.032 1.964 1.392 3.07.271 2.92-2.968 5.93-5.858 8.693-8.968a6.238 6.238 0 0 0-8.596-8.99c-.502.375-.966.823-1.487 1.266h-.016Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const LGBTQIcon = ({ width = "60", height = "38", ...props }) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 60 38">
        <Path
            d="M37.5 37.5h-4V30a3.5 3.5 0 1 0-7 0v7.5h-4V30a7.5 7.5 0 0 1 7.5-7.5 7.5 7.5 0 0 1 7.5 7.5v7.5Zm7.5 0h-4V30c0-6.075-4.925-11.002-11-11.002S19 23.925 19 30v7.5h-4V30c0-8.285 6.715-15 15-15s15 6.715 15 15v7.5Zm7.5 0h-4V30c0-10.219-8.284-18.502-18.5-18.502S11.5 19.781 11.5 30v7.5h-4V30C7.5 17.573 17.573 7.5 30 7.5S52.5 17.573 52.5 30v7.5Zm7.5 0h-4V30C56 15.64 44.36 3.998 30 3.998S4 15.64 4 30v7.5H0V30C0 13.43 13.432 0 30 0c16.568 0 30 13.43 30 30v7.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const MentalHealthIcon = ({
    width = "297.333",
    height = "285.333",
    ...props
}) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 223 214">
        <G fill="currentColor" fillRule="evenodd">
            <Path d="M95.1 14.3c-7.8 2.5-15 6.9-20.6 12.5-24.1 24.1-15.7 64.9 16.1 77.7 26.1 10.5 56.4-4.9 63.5-32.1 5.8-22.4-5-45.2-26.2-55.3-7.3-3.4-8.5-3.7-18.3-3.9-6.7-.2-12 .2-14.5 1.1z" />
            <Path d="M55.6 110.9C44.3 115 34.5 124.1 29.7 135c-3.3 7.5-4.3 17.3-3.9 41.8.3 21.4.4 23.2 2.4 25.8 1.1 1.5 3.6 3.6 5.5 4.5 3.1 1.7 9.1 1.8 80.3 1.8h76.8l-.4-32.2c-.5-36.3-.9-38.5-8.6-49.7-9-13.1-29.9-22-38-16.2-18.1 12.7-43.1 14.7-62.6 4.9-3.4-1.7-7.3-3.9-8.8-4.9-3.4-2.5-9.7-2.4-16.8.1zm47 33c2.1 1.1 4.1 2.4 4.5 3 .3.6 2.2-.1 4.6-1.7 7.9-5.2 18-3.9 21.6 3 4.5 8.7.9 18.2-11.9 30.9-9.3 9.3-12.4 10.9-16.4 8.7-4.4-2.3-19-17.7-21.4-22.6-4.2-8.5-2.2-19 4.2-22.1 3.7-1.7 10.5-1.4 14.8.8z" />
        </G>
    </Svg>
);

export const ParentingAndPregancyIcon = ({
    width = "189",
    height = "208",
    ...props
}) => (
    <Svg
        {...props}
        width={width}
        height={height}
        viewBox="0 0 189 208"
        fill="none">
        <G clipPath="url(#a)" fill="currentColor">
            <Path d="m187.717 129.712-18.746-29.177a4.008 4.008 0 0 0-2.666-1.722 2.99 2.99 0 0 0-.381-.053c-.088 0-.179-.023-.267-.027-.087-.004-.08 0-.122 0h-7.16l-4.951 2.381h-8.969l-4.818-2.38h-7.289c-.084 0-.164 0-.248.022a2.636 2.636 0 0 0-2.434 1.12l-.499 32.354v2.129l-4.536 64.798c-.51 4.163 3.12 7.804 7.781 7.804 3.851 0 7.134-2.521 7.732-5.941l3.557-37.842c.232-2.453 2.514-4.338 5.256-4.338 2.738 0 5.023 1.904 5.252 4.338l3.561 37.842c.598 3.428 3.877 5.941 7.731 5.941 4.662 0 8.288-3.637 7.781-7.804l-4.509-64.856-.035-2.563L172.76 138c2.506 3.9 8.147 5.149 12.401 2.666 3.98-2.335 4.932-7.256 2.556-10.954ZM148.942 97.614c9.774 0 17.698-7.924 17.698-17.699 0-9.775-7.924-17.698-17.698-17.698-9.775 0-17.699 7.924-17.699 17.698 0 9.775 7.924 17.698 17.699 17.698ZM105.943 111.302a12.84 12.84 0 0 1-8.497 1.717l-2.22-.522h-.039l-6.474-5.035 3.71-3.016 11.337-9.217 1.41-1.142 4.524 1.744c3.059 5.29 1.676 12.176-3.751 15.471Z" />
            <Path d="m134.141 98.783-2.772 17.774-1.973-.072-20.349-.762-.929-.217.285-.167a15.72 15.72 0 0 0 7.183-9.819c.581-2.447.59-4.995.027-7.446l1.763.678h16.765v.03Z" />
            <Path d="M105.943 111.301a12.841 12.841 0 0 1-8.497 1.718 12.623 12.623 0 0 1-2.22-.522h-.027a11.956 11.956 0 0 1-6.475-5.035l-5.59-9.045.049 3.702 6.261 93.717c.705 6.018-4.334 11.274-10.805 11.274-5.332 0-9.902-3.641-10.74-8.585l-4.951-54.679a6.656 6.656 0 0 0-2.342-4.464 7.588 7.588 0 0 0-4.951-1.805c-3.809 0-6.982 2.723-7.302 6.269l-4.95 54.679a10.014 10.014 0 0 1-3.676 6.147 11.318 11.318 0 0 1-7.065 2.438c-6.474 0-11.517-5.26-10.805-11.278l6.3-93.629v-3.081l-5.587 9.049c-3.478 5.633-11.316 7.442-17.227 3.854-5.537-3.363-6.855-10.47-3.56-15.817L28.85 52.375a3.592 3.592 0 0 1 3.382-1.618c.114 0 .225-.035.339-.035h10.146l2.533 1.3 4.166 2.136H61.89l4.76-2.37 2.141-1.066h9.94c.062 0 .115 0 .172.02.126 0 .248 0 .38.034.172.017.343.043.511.08a5.561 5.561 0 0 1 3.702 2.483l26.001 42.145c.069.11.134.218.194.328 3.063 5.309 1.68 12.195-3.747 15.489Z" />
            <Path d="M80.231 26.584a24.595 24.595 0 0 1-33.035 23.092 24.585 24.585 0 1 1 33.05-23.084l-.015-.008Z" />
        </G>
        <Defs>
            <ClipPath id="a">
                <Path fill="#fff" d="M0 0h189v207.094H0z" />
            </ClipPath>
        </Defs>
    </Svg>
);

export const AngryEmoji = ({
    width = "24",
    height = "24",
    color,
}: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 45 45">
        <Path
            d="m33.784 11.435-8.157 3.804a1 1 0 0 0 .845 1.812l8.158-3.804a1 1 0 0 0-.846-1.812Zm-14.835 5.71a1.001 1.001 0 0 0 .424-1.906l-8.156-3.804a1 1 0 1 0-.846 1.812l8.156 3.804c.137.064.28.094.422.094Zm13.252-1-4.336 1.86a3.07 3.07 0 0 0-.14.871 3.08 3.08 0 1 0 6.161 0c0-1.196-.689-2.22-1.685-2.73Zm-14.927 2.731a3.07 3.07 0 0 0-.139-.87l-4.337-1.86a3.07 3.07 0 0 0-1.684 2.73 3.08 3.08 0 1 0 6.16 0ZM30.01 29.77a10.553 10.553 0 0 0-7.499-3.1 10.553 10.553 0 0 0-7.524 3.123l-1.1 1.096A1.578 1.578 0 0 0 15 33.58c.422 0 .817-.165 1.114-.46l1.103-1.108a7.623 7.623 0 0 1 5.283-2.115c1.976 0 3.853.751 5.29 2.12l1.01 1.014h.016l.088.088c.298.296.694.461 1.115.461a1.574 1.574 0 0 0 1.115-2.69l-1.124-1.12ZM22.5 42C11.73 42 3 33.27 3 22.5 3 11.73 11.73 3 22.5 3S42 11.73 42 22.5C42 33.27 33.27 42 22.5 42Zm0-42C10.073 0 0 10.074 0 22.5 0 34.926 10.073 45 22.5 45S45 34.926 45 22.5C44.987 10.08 34.921.012 22.5 0Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const SadEmoji = ({ width = "24", height = "24", color }: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 45 45">
        <Path
            d="M29.273 13.823a3.417 3.417 0 0 0-1.854 3.038c0 1.892 1.518 3.426 3.39 3.426 1.82 0 3.295-1.453 3.376-3.274l-4.9-3.185-.012-.005Zm-14.275 6.329a3.363 3.363 0 0 0 2.492-2.493c.38-1.648-.446-3.135-1.76-3.808l-4.906 3.158a3.384 3.384 0 0 0 4.174 3.143Zm15.01 9.617a10.552 10.552 0 0 0-7.498-3.099 10.55 10.55 0 0 0-7.523 3.123l-1.101 1.095a1.567 1.567 0 0 0-.462 1.115c0 .421.164.817.462 1.115.298.297.693.461 1.115.461.42 0 .816-.164 1.113-.461l1.103-1.107a7.625 7.625 0 0 1 5.284-2.115c1.976 0 3.852.751 5.288 2.12l1.009 1.014h.018l.088.088a1.57 1.57 0 0 0 1.115.461 1.578 1.578 0 0 0 1.115-2.69l-1.125-1.12ZM22.502 42C11.73 42 3 33.269 3 22.5 3 11.73 11.73 3 22.5 3 33.27 3 42 11.73 42 22.5 42 33.269 33.27 42 22.5 42Zm0-42C10.074 0 0 10.074 0 22.5 0 34.927 10.074 45 22.5 45 34.927 45 45 34.927 45 22.5 44.987 10.079 34.92.012 22.5 0Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const OverwhelmedEmoji = ({
    width = "24",
    height = "24",
    color,
}: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 45 45">
        <Path
            d="M33.158 30.04a2.382 2.382 0 0 1-1.368-.546c-.098-.081-.217-.224-.343-.375-.336-.4-.795-.947-1.57-1.234-1.042-.388-2.23-.144-3.345.684l-.2.15c-1.885 1.404-2.049 1.31-2.72.508-.335-.403-1.122-1.344-2.345-1.49-.995-.121-1.99.313-2.943 1.284-.664.677-1.326 1.073-1.769 1.04-.097-.004-.393-.021-.815-.565a4.944 4.944 0 0 0-3.387-1.875 1.407 1.407 0 0 0-.284 2.798 2.145 2.145 0 0 1 1.45.803c.997 1.283 2.114 1.604 2.875 1.648.067.004.134.006.201.006 1.237 0 2.525-.648 3.738-1.887.397-.405.594-.455.592-.461.04.013.184.089.527.5 2.49 2.982 5.038 1.08 6.562-.055l.194-.146c.372-.276.638-.322.692-.306.075.029.265.254.39.404.192.229.41.489.704.733a5.197 5.197 0 0 0 3.018 1.192c.764.02 1.437-.556 1.477-1.332a1.407 1.407 0 0 0-1.33-1.478M22.5 42C11.73 42 3 33.269 3 22.5 3 11.73 11.73 3 22.5 3S42 11.73 42 22.5C42 33.269 33.27 42 22.5 42m0-42C10.074 0 0 10.074 0 22.5 0 34.927 10.074 45 22.5 45S45 34.927 45 22.5C44.987 10.079 34.921.013 22.5 0m7.962 15.375c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m0 5.196a3.696 3.696 0 1 0 0-7.392 3.697 3.697 0 1 0 0 7.392m-15.924-5.196c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m0 5.196a3.697 3.697 0 1 0 .001-7.393 3.697 3.697 0 0 0 0 7.393"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const NeutralEmoji = ({
    width = "24",
    height = "24",
    color,
}: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 45 45">
        <Path
            d="M32.347 28.816H12.652a1.309 1.309 0 0 0 0 2.615h19.695a1.309 1.309 0 0 0 0-2.615m-2.542-8.86a3.08 3.08 0 1 0-.001-6.162 3.08 3.08 0 0 0 .001 6.162m-14.61 0a3.08 3.08 0 1 0-.001-6.162 3.08 3.08 0 0 0 .001 6.162M22.5 42C11.73 42 3 33.27 3 22.5S11.73 3 22.5 3 42 11.73 42 22.5 33.27 42 22.5 42m0-42C10.073 0 0 10.074 0 22.5S10.073 45 22.5 45C34.926 45 45 34.926 45 22.5 44.987 10.08 34.921.012 22.5 0"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const HappyEmoji = ({
    width = "24",
    height = "24",
    color,
}: SvgProps) => (
    <Svg color={color} width={width} height={height} viewBox="0 0 45 45">
        <Path
            d="M30.965 26.598c-.377 0-.731.146-1.015.43l-.118.098-1.133 1.137a8.945 8.945 0 0 1-6.2 2.481 8.966 8.966 0 0 1-6.214-2.493l-1.235-1.24a1.395 1.395 0 0 0-.997-.413 1.413 1.413 0 0 0-.999 2.407l1.243 1.238a11.52 11.52 0 0 0 8.212 3.408c3.092 0 6.009-1.21 8.214-3.41l1.24-1.235a1.414 1.414 0 0 0 0-1.995 1.4 1.4 0 0 0-.998-.413M22.5 42C11.73 42 3 33.27 3 22.5 3 11.731 11.73 3 22.5 3 33.269 3 42 11.731 42 22.5 42 33.27 33.269 42 22.5 42m0-42C10.073 0 0 10.075 0 22.5 0 34.927 10.073 45 22.5 45 34.926 45 45 34.927 45 22.5 44.987 10.08 34.921.013 22.5 0M30 13.725a5.032 5.032 0 0 0-5.026 5.025c0 .703.573 1.276 1.276 1.276.703 0 1.275-.573 1.275-1.276A2.477 2.477 0 0 1 30 16.276a2.477 2.477 0 0 1 2.474 2.474c0 .703.573 1.276 1.276 1.276.703 0 1.275-.573 1.275-1.276A5.031 5.031 0 0 0 30 13.725m-15 2.551a2.477 2.477 0 0 1 2.474 2.474c0 .703.573 1.276 1.276 1.276.703 0 1.275-.573 1.275-1.276A5.031 5.031 0 0 0 15 13.725a5.032 5.032 0 0 0-5.026 5.025c0 .703.573 1.276 1.276 1.276.703 0 1.275-.573 1.275-1.276A2.477 2.477 0 0 1 15 16.276"
            fill="currentColor"
            fillRule="evenodd"
        />
    </Svg>
);

export const AboutScienceSafety = ({
    width = "364",
    height = "212",
    ...props
}: SvgProps) => (
    <Svg {...props} width={width} height={height} viewBox="0 0 364 212">
        <G fill="none" fillRule="evenodd">
            <G fillRule="nonzero">
                <Path
                    d="M154.38 1V94.06l65.825-65.825C202.017 10.078 180.075 1 154.38 1Z"
                    fill="#FCCB68"
                />
                <Path
                    d="M154.38 1h-1.062c-25.234.247-46.806 9.325-64.717 27.235-18.187 18.156-27.28 40.097-27.28 65.824 0 25.696 9.093 47.622 27.28 65.778 17.91 17.91 39.483 26.988 64.717 27.234h1.062c25.357 0 47.052-8.832 65.086-26.496L154.38 94.06V1Z"
                    fill="#5ED1CE"
                />
                <Path
                    d="M247.439 94.059c0-5.57-.416-10.956-1.247-16.156L154.38 94.059l65.086 66.516.739-.739c18.155-18.155 27.234-40.081 27.234-65.777Z"
                    fill="#C49639"
                />
                <Path
                    d="M246.192 77.903c-1.26-7.663-3.446-14.956-6.554-21.88-4.493-10.063-10.97-19.326-19.433-27.788L154.38 94.059l91.812-16.156Z"
                    fill="#E2B346"
                />
            </G>
            <G fill="#FFF" fillRule="nonzero" stroke="#6D6E70" strokeWidth={5}>
                <Path d="M133.88 189.706c2.675-3.976 4.246-8.685 4.246-13.751 0-14.16-12.112-25.639-27.054-25.639a28.4 28.4 0 0 0-8.174 1.194c-5.143-15.267-20.228-26.327-38.043-26.327-22.054 0-39.932 16.943-39.932 37.844 0 .775.032 1.542.081 2.305a19.67 19.67 0 0 0-2.994-.231c-10.26 0-19.508 7.943-19.508 18.488 0 2.194.368 4.237 1.006 6.116H133.88v.001Z" />
                <Path d="M357.133 208.645a35.459 35.459 0 0 0 3.98-16.342c0-19.528-15.669-35.358-34.997-35.358-3.686 0-7.238.58-10.574 1.647-6.652-21.055-19.769-36.115-49.213-36.308-17.303-.112-29.789 11.295-39.163 24.491-2.781-.577-8.576-3.573-15.722-3.573-21.44 0-33.547 16.29-37.164 35.901-2.546 0-40.019-.393-61.013-.393-7.68 0-26.222 1.003-26.222 24.122 0 2.102.211 4.024.566 5.813h269.522Z" />
            </G>
            <Path
                d="M303.012 85.767s12.947 1.083 17.755 14.861c.627 1.798 6.35-13.411 21.383-10.712M278.545 53.667s8.897.051 14.628 8.439c.748 1.094 2.139-10.712 12.731-11.625"
                stroke="#5ED1CE"
                strokeWidth={6.684}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </G>
    </Svg>
);
